import {
  FETCH_CUSTOMER_PLATFORM_LIST,
  RESET_CUSTOMER_PLATFORM_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
};

const customerPlatformListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_PLATFORM_LIST:
      return { list: action.payload };
    case RESET_CUSTOMER_PLATFORM_LIST:
      return initialState;
    default:
      return state;
  }
};

export default customerPlatformListReducer;
